import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApiInstance from "app/services/axios";
import {
  getDataEndPoint,
  updateDataEndPoint,
  insertDataEndPoint,
  getBidderResponseDataEndPoint,
  getPublisherResponseDataEndPoint,
  getBidderPubRevShareDataEndPoint,
  updateBidderPubRevShareDataEndPoint,
} from "app/utils/constants/paths";
import { DATASOURCE_CONFIG } from "app/config";
import { addslashes, parseJsonString } from "app/utils/utils";
let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  demandPartnersList: [],
  bidderGroups: [],
  customDspList: [],
  endpointRegionList: [],
  parameterFlag: false,
  submitLoading: false,
  locationGroupLoading: false,
  demandPartnerInventoryLoading: false,
  bidderEndPointCount: [],
};

export const GetAllDemandPartnersListThunk = createAsyncThunk(
  "demandpartner/GetAllDemandPartnersListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    let condition = [];
    if (
      payload?.search != "" &&
      payload?.search != undefined &&
      payload?.search != null
    ) {
      condition.push(
        "name " + DATASOURCE_CONFIG.QUERY_LIKE + " '%" + payload.search + "%'"
      );
    }

    if (isSysAdmin != 1) {
      let authBidAccounts = payload.authUserData?.user_assoc_accounts?.bidder
        ? payload.authUserData?.user_assoc_accounts?.bidder
        : [];
      if (authBidAccounts.length > 0) {
        condition.push("accountid IN ('" + authBidAccounts.join("','") + "')");
      }
    } else {
      condition.push("auto_id NOT IN (2,3,3642)");
    }
    condition.push("active ='1'");
    let where = "";
    if (condition.length > 0) {
      where = "where " + condition.join(" and ") + "";
    }
    const queryBody = {
      queries: [
        {
          query:
            `select id,name,email,accountid,imp_type,creation_date,active,(select company from ${tablePrefix}accounts where id=accountid ) as account_name from ${tablePrefix} bidders ` +
            where +
            ` order by id desc`,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };

    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAllDemandPartnerParameterListThunk = createAsyncThunk(
  "demandpartner/GetAllDemandPartnerParameterListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    let condition = [];
    if (isSysAdmin != 1) {
    }
    let where = "";
    if (condition.length > 0) {
      where = "where " + condition.join(" and ") + "";
    }

    const queryBody = {
      queries: [
        {
          query:
            "Select id as value,custom_handler as handler,name as label,method,global_mapping_structure as g_m_s,inv_mapping_structure as i_m_s,inv_category_mapping as c_m_s,auction_type from " +
            tablePrefix +
            "custom_dsps_info ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "Select id as value,name as label,accountid from " +
            tablePrefix +
            "bidder_groups " +
            where +
            "",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query: "select * from " + tablePrefix + "dc where active='1' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "SELECT accountid,COUNT(auto_id) AS bidders_count FROM  " +
            tablePrefix +
            "bidders where accountid IN('" +
            payload.account.join("','") +
            "') GROUP BY accountid",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const InsertBidderDetailsThunk = createAsyncThunk(
  "demandpartner/InsertBidderDetailsThunk",
  async (payload) => {
    let insertBidderQuery =
      "insert into " +
      tablePrefix +
      "bidders (name,imp_type,custom_handler_id,accountid,group_id,email,days_email_report,email_report_type,daily_email_report_timezone_country,support_email,target_size,size_based_ecpm_range,support_multiple_adsizes,margin,gzip,auction_type,rtb_version,enable_auction_notifications,custom_scripts,is_seat_on_platform,is_pmp,wseat_mandatory,wseat,video_on_load,min_tmax,last_changes,cookie_match_only_traffic,regional_endpoints_info,custom_pixels,daily_budget,daily_impressions,country_qps,bundleid_qps,qps_optimization,qps_optimization_results,qps_optimization_test_traffic_percentage,qps_optimization_rolling_winder_minutes,min_bid_rate,min_render_rate,min_gecpm_rate,min_win_rate,min_click_rate,min_completion_rate,qps_soft_limit_gecpm,qps_opt_min_profit_margin,rev_share,response_rev_share,target_app_language,target_app,target_cat,target_pubs,target_placements,target_supply_deal_id,target_bundles,target_devicetype,target_device_os,target_gender,target_age,target_country,target_skippable,created_by,custom_ingestion,custom_processor,method,is_whitelist_creatives,pchain_only,creation_date,updated) values('" +
      addslashes(payload.name) +
      "','" +
      payload.bidder_type +
      "','" +
      payload.integration +
      "','" +
      payload.account +
      "','" +
      payload.group +
      "','" +
      addslashes(payload.email) +
      "','" +
      payload.email_report +
      "','" +
      payload.email_report_type +
      "','" +
      payload.report_timezone_country +
      "','" +
      payload.ad_quality_email +
      "','" +
      payload.target_size +
      "','" +
      payload.sizes_ecpm +
      "','" +
      payload.support_multiple_adsizes +
      "','" +
      payload.margin +
      "','" +
      payload.request_compression +
      "','" +
      payload.auction_type +
      "','" +
      payload.rtb_version +
      "','" +
      payload.lossNotification +
      "','" +
      payload.custom_script +
      "','" +
      payload.seat_type +
      "','" +
      payload.pmp_supply_only +
      "','" +
      payload.seatid_selection_only +
      "','" +
      payload.buyer_seat_whitelist +
      "','" +
      payload.video_on_load +
      "','" +
      payload.min_tmax +
      "','" +
      payload.session_comment +
      "','" +
      payload.cookie_sync_traffice +
      "','" +
      payload.regional_endpoints_info +
      "','" +
      payload.tracking_pixel +
      "','" +
      payload.daily_spend +
      "','" +
      payload.daily_impressions +
      "','" +
      payload.country_qps +
      "','" +
      payload.bundle_qps +
      "','" +
      payload.qps_optimization +
      "','" +
      payload.qps_optimization_parameters +
      "','" +
      payload.qps_opt_test_traffic_age +
      "','" +
      payload.qps_opt_expire_time +
      "','" +
      payload.min_bid_rate +
      "','" +
      payload.min_render_rate +
      "','" +
      payload.min_gecpm_rate +
      "','" +
      payload.min_win_rate +
      "','" +
      payload.min_click_rate +
      "','" +
      payload.min_completion_rate +
      "','" +
      payload.soft_limit +
      "','" +
      payload.min_profit_margin +
      "','" +
      payload.rev_share +
      "','" +
      payload.response_rev_share +
      "','" +
      payload.target_app_language +
      "','" +
      payload.target_app +
      "','" +
      payload.target_cats +
      "','" +
      payload.target_pubs +
      "','" +
      payload.target_placements +
      "','" +
      payload.target_supply_deal_id +
      "','" +
      payload.target_bundles +
      "','" +
      payload.target_devicetype +
      "','" +
      payload.target_device_os +
      "','" +
      payload.target_gender +
      "','" +
      payload.target_age +
      "','" +
      payload.country +
      "','" +
      payload.target_skippable +
      "','" +
      payload.created_by +
      "','" +
      payload.custom_ingestion +
      "','" +
      payload.custom_processor +
      "','" +
      payload.method +
      "','" +
      payload.is_whitelist_creatives +
      "','" +
      payload.pchain_only +
      "'," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      "," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      ")";
    console.log("insertBidderQuery", insertBidderQuery);

    const queryBody = {
      queries: [
        {
          query: insertBidderQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          tableName: "bidders",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        insertDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const InsertUpdateBidderDetailsThunk = createAsyncThunk(
  "demandpartner/InsertUpdateBidderDetailsThunk",
  async (payload) => {
    let insertUpdateBidderQuery = "";
    let publisherRevshareValuesArr = [];
    let bidderId = payload.id;
    if (payload.publisher_revShare.length > 0) {
      payload.publisher_revShare.map((pinfo) => {
        publisherRevshareValuesArr.push(
          "('" +
            pinfo.id +
            "','" +
            bidderId +
            "','" +
            pinfo.pub_code +
            "','" +
            pinfo.revShare +
            "'," +
            DATASOURCE_CONFIG.CURRENT_DATE +
            ")"
        );
      });
    }
    let BidDealAssocQuery = [];
    if (payload.action == "add") {
      // insertUpdateBidderQuery =
      //   "insert into " +
      //   tablePrefix +
      //   "bidders  (id,name,imp_type,custom_handler_id,accountid,group_id,email,days_email_report,email_report_type,daily_email_report_timezone_country,support_email,target_size,size_based_ecpm_range,support_multiple_adsizes,margin,gzip,auction_type,rtb_version,enable_auction_notifications,custom_scripts,is_seat_on_platform,is_pmp,wseat_mandatory,wseat,video_on_load,min_tmax,last_changes,cookie_match_only_traffic,regional_endpoints_info,custom_pixels,daily_budget,daily_impressions,country_qps,bundleid_qps,qps_optimization,qps_optimization_results,qps_optimization_test_traffic_percentage,qps_optimization_rolling_winder_minutes,min_bid_rate,min_render_rate,min_gecpm_rate,min_win_rate,min_click_rate,min_completion_rate,qps_soft_limit_gecpm,qps_opt_min_profit_margin,rev_share,target_app_language,target_app,target_cat,target_pubs,target_placements,target_supply_deal_id,target_devicetype,target_device_os,target_gender,target_age,target_country,target_skippable,created_by,custom_ingestion,custom_processor,method,auto_id,creation_date,updated) values('" +
      //   payload.id +
      //   "','" +
      //   payload.name +
      //   "','" +
      //   payload.bidder_type +
      //   "','" +
      //   payload.integration +
      //   "','" +
      //   payload.account +
      //   "','" +
      //   payload.group +
      //   "','" +
      //   payload.email +
      //   "','" +
      //   payload.email_report +
      //   "','" +
      //   payload.email_report_type +
      //   "','" +
      //   payload.report_timezone_country +
      //   "','" +
      //   payload.ad_quality_email +
      //   "','" +
      //   payload.target_size +
      //   "','" +
      //   payload.sizes_ecpm +
      //   "','" +
      //   payload.support_multiple_adsizes +
      //   "','" +
      //   payload.margin +
      //   "','" +
      //   payload.request_compression +
      //   "','" +
      //   payload.auction_type +
      //   "','" +
      //   payload.rtb_version +
      //   "','" +
      //   payload.lossNotification +
      //   "','" +
      //   payload.custom_script +
      //   "','" +
      //   payload.seat_type +
      //   "','" +
      //   payload.pmp_supply_only +
      //   "','" +
      //   payload.seatid_selection_only +
      //   "','" +
      //   payload.buyer_seat_whitelist +
      //   "','" +
      //   payload.video_on_load +
      //   "','" +
      //   payload.min_tmax +
      //   "','" +
      //   payload.session_comment +
      //   "','" +
      //   payload.cookie_sync_traffice +
      //   "','" +
      //   payload.regional_endpoints_info +
      //   "','" +
      //   payload.tracking_pixel +
      //   "','" +
      //   payload.daily_spend +
      //   "','" +
      //   payload.daily_impressions +
      //   "','" +
      //   payload.country_qps +
      //   "','" +
      //   payload.bundle_qps +
      //   "','" +
      //   payload.qps_optimization +
      //   "','" +
      //   payload.qps_optimization_parameters +
      //   "','" +
      //   payload.qps_opt_test_traffic_age +
      //   "','" +
      //   payload.qps_opt_expire_time +
      //   "','" +
      //   payload.min_bid_rate +
      //   "','" +
      //   payload.min_render_rate +
      //   "','" +
      //   payload.min_gecpm_rate +
      //   "','" +
      //   payload.min_win_rate +
      //   "','" +
      //   payload.min_click_rate +
      //   "','" +
      //   payload.min_completion_rate +
      //   "','" +
      //   payload.soft_limit +
      //   "','" +
      //   payload.min_profit_margin +
      //   "','" +
      //   payload.rev_share +
      //   "','" +
      //   payload.target_app_language +
      //   "','" +
      //   payload.target_app +
      //   "','" +
      //   payload.target_cats +
      //   "','" +
      //   payload.target_pubs +
      //   "','" +
      //   payload.target_placements +
      //   "','" +
      //   payload.target_supply_deal_id +
      //   "','" +
      //   payload.target_devicetype +
      //   "','" +
      //   payload.target_device_os +
      //   "','" +
      //   payload.target_gender +
      //   "','" +
      //   payload.target_age +
      //   "','" +
      //   payload.country +
      //   "','" +
      //   payload.target_skippable +
      //   "','" +
      //   payload.created_by +
      //   "','" +
      //   payload.custom_ingestion +
      //   "','" +
      //   payload.custom_processor +
      //   "','" +
      //   payload.method +
      //   "'," +
      //   DATASOURCE_CONFIG.CURRENT_DATE +
      //   "," +
      //   DATASOURCE_CONFIG.CURRENT_DATE +
      //   ")";
      // console.log("insertUpdateBidderQuery", insertUpdateBidderQuery);
    } else {
      var inventoryTabFields = "";
      if (payload?.update_inventory_tab) {
        inventoryTabFields =
          ",target_pubs='" +
          payload.target_pubs +
          "',target_placements='" +
          payload.target_placements +
          "',target_supply_deal_id='" +
          payload.target_supply_deal_id +
          "',target_bundles='" +
          payload.target_bundles +
          "',target_app_language='" +
          payload.target_app_language +
          "',target_app='" +
          payload.target_app +
          "',target_cat='" +
          payload.target_cats +
          "',target_skippable='" +
          payload.target_skippable +
          "'";
      }
      insertUpdateBidderQuery =
        "update" +
        tablePrefix +
        " bidders set name='" +
        addslashes(payload.name) +
        "',accountid='" +
        payload.account +
        "',group_id='" +
        payload.group +
        "',email='" +
        addslashes(payload.email) +
        "',days_email_report='" +
        payload.email_report +
        "',email_report_type='" +
        payload.email_report_type +
        "',daily_email_report_timezone_country='" +
        payload.report_timezone_country +
        "',support_email='" +
        payload.ad_quality_email +
        "',target_size='" +
        payload.target_size +
        "',size_based_ecpm_range='" +
        payload.sizes_ecpm +
        "',support_multiple_adsizes='" +
        payload.support_multiple_adsizes +
        "',margin='" +
        payload.margin +
        "',gzip='" +
        payload.request_compression +
        "',auction_type='" +
        payload.auction_type +
        "',rtb_version='" +
        payload.rtb_version +
        "',enable_auction_notifications='" +
        payload.lossNotification +
        "',custom_scripts='" +
        payload.custom_script +
        "',is_seat_on_platform='" +
        payload.seat_type +
        "',is_pmp='" +
        payload.pmp_supply_only +
        "',wseat_mandatory='" +
        payload.seatid_selection_only +
        "',wseat='" +
        payload.buyer_seat_whitelist +
        "',video_on_load='" +
        payload.video_on_load +
        "',min_tmax='" +
        payload.min_tmax +
        "',last_changes='" +
        payload.session_comment +
        "',cookie_match_only_traffic='" +
        payload.cookie_sync_traffice +
        "',regional_endpoints_info='" +
        payload.regional_endpoints_info +
        "',custom_pixels='" +
        payload.tracking_pixel +
        "',daily_budget='" +
        payload.daily_spend +
        "',daily_impressions='" +
        payload.daily_impressions +
        "',country_qps='" +
        payload.country_qps +
        "',bundleid_qps='" +
        payload.bundle_qps +
        "',qps_optimization='" +
        payload.qps_optimization +
        "',qps_optimization_results='" +
        payload.qps_optimization_parameters +
        "',qps_optimization_test_traffic_percentage='" +
        payload.qps_opt_test_traffic_age +
        "',qps_optimization_rolling_winder_minutes='" +
        payload.qps_opt_expire_time +
        "',min_bid_rate='" +
        payload.min_bid_rate +
        "',min_render_rate='" +
        payload.min_render_rate +
        "',min_gecpm_rate='" +
        payload.min_gecpm_rate +
        "',min_win_rate='" +
        payload.min_win_rate +
        "',min_click_rate='" +
        payload.min_click_rate +
        "',min_completion_rate='" +
        payload.min_completion_rate +
        "',qps_soft_limit_gecpm='" +
        payload.soft_limit +
        "',qps_opt_min_profit_margin='" +
        payload.min_profit_margin +
        "',rev_share='" +
        payload.rev_share +
        "',response_rev_share='" +
        payload.response_rev_share +
        "',target_devicetype='" +
        payload.target_devicetype +
        "',target_device_os='" +
        payload.target_device_os +
        "',target_gender='" +
        payload.target_gender +
        "',target_age='" +
        payload.target_age +
        "',target_country='" +
        payload.country +
        "',custom_ingestion='" +
        payload.custom_ingestion +
        "',custom_processor='" +
        payload.custom_processor +
        "',method='" +
        payload.method +
        "',is_whitelist_creatives='" +
        payload.is_whitelist_creatives +
        "',pchain_only='" +
        payload.pchain_only +
        "' " +
        inventoryTabFields +
        ",updated=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        " where id='" +
        bidderId +
        "'";

      if (payload.dealAssoc.length > 0) {
        var dealsIdString = "'" + payload.dealAssoc.join("','") + "'";
        BidDealAssocQuery = [
          {
            query:
              "UPDATE " +
              tablePrefix +
              "rtb_dealid_bidder_assoc set visible=0,date_updated=" +
              DATASOURCE_CONFIG.CURRENT_DATE +
              "  where bidder_id='" +
              bidderId +
              "' AND dealid IN (" +
              dealsIdString +
              ")",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          },
        ];
      } else {
        if (payload.isAllBidDealAssoc == 0) {
          BidDealAssocQuery = [
            {
              query:
                "UPDATE " +
                tablePrefix +
                "rtb_dealid_bidder_assoc set visible=0,date_updated=" +
                DATASOURCE_CONFIG.CURRENT_DATE +
                "  where bidder_id='" +
                bidderId +
                "' ",
              datasource: DATASOURCE_CONFIG.DATASOURCE,
            },
          ];
        }
      }
    }
    console.log("BidDealAssocQuery", BidDealAssocQuery);

    let bidQuery = [];
    let queryArr = [];
    if (
      insertUpdateBidderQuery != "" &&
      insertUpdateBidderQuery != undefined &&
      insertUpdateBidderQuery != null
    ) {
      bidQuery = [
        {
          query: insertUpdateBidderQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ];
    }
    let deletepubRevsharequeryArr = [
      {
        query:
          "Delete from " +
          tablePrefix +
          "publisher_bidder_rev_share where dspid='" +
          bidderId +
          "' and (adsize='' OR adsize is NULL)",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      },
    ];
    queryArr = [...bidQuery, ...deletepubRevsharequeryArr];
    if (publisherRevshareValuesArr.length > 0) {
      let pubRevshareQuery = [
        {
          query:
            "insert into " +
            tablePrefix +
            "publisher_bidder_rev_share (id,dspid,pub_code,rev_share,updated) values " +
            publisherRevshareValuesArr.join(",") +
            "",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ];

      queryArr = [...queryArr, ...pubRevshareQuery, ...BidDealAssocQuery];
    }
    if (BidDealAssocQuery.length > 0) {
      queryArr = [...queryArr, ...BidDealAssocQuery];
    }

    console.log("queryArr", queryArr);
    const queryBody = {
      queries: queryArr,
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const CreateUpdateBidderLocationDetailsThunk = createAsyncThunk(
  "demandpartner/CreateUpdateBidderLocationDetailsThunk",
  async (payload) => {
    let queriesArr = [];
    var bidderId = payload.bidder_id;
    var action = payload.action;
    if (payload.is_location) {
      let InsertQuery =
        "insert into " +
        tablePrefix +
        "bidders_location_groups (id,bidder_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,creation_date,updated_date,created_by) values";
      let InsertValuesArr = [];

      let InsertLocationLatLongValues = [];
      let InsertLocationAddressesValues = [];
      let InsertLocationPolygongValues = [];
      let InsertLocationPoiValues = [];

      var locationGroupFieldsInfo = payload.formInfo;

      if (action == "edit" && locationGroupFieldsInfo.length) {
        queriesArr.push({
          query:
            "update " +
            tablePrefix +
            "bidders_location_groups set is_active=0 where  bidder_id='" +
            bidderId +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      for (var n = 0; n < locationGroupFieldsInfo.length; n++) {
        var locationInfo = locationGroupFieldsInfo[n];
        console.log("biddder-locationInfo:", locationInfo);
        var locId = "";
        if (
          locationInfo.id == "" ||
          locationInfo.id == null ||
          locationInfo.id == undefined
        ) {
          // Create case
          //var insertId = uuid();
          locId = locationInfo.insert_id;
          InsertValuesArr.push(
            "('" +
              locId +
              "','" +
              bidderId +
              "','" +
              addslashes(locationInfo.name) +
              "','" +
              locationInfo.target_city +
              "','" +
              locationInfo.target_state +
              "','" +
              locationInfo.target_dma +
              "','" +
              locationInfo.target_counties +
              "','" +
              locationInfo.target_zipcode +
              "','" +
              locationInfo.target_brands +
              "','" +
              locationInfo.target_congressional_districts +
              "','" +
              locationInfo.target_senate_districts +
              "','" +
              locationInfo.target_house_districts +
              "','" +
              locationInfo.latlon_radius +
              "','" +
              locationInfo.addresses_radius +
              "','" +
              locationInfo.poi_radius +
              "','" +
              addslashes(locationInfo.target_latlon) +
              "','" +
              addslashes(locationInfo.target_polygon) +
              "','" +
              addslashes(locationInfo.target_poi) +
              "','" +
              addslashes(locationInfo.target_addresses) +
              "','" +
              locationInfo.target_latlon_group +
              "','" +
              locationInfo.target_polygon_group +
              "','" +
              locationInfo.target_address_group +
              "'," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              "," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              ",'" +
              locationInfo.created_by +
              "')"
          );
          //geo_points,geo_polygons
        } else {
          // Update case
          locId = locationInfo.id;
          queriesArr.push({
            query:
              "update " +
              tablePrefix +
              "bidders_location_groups set is_active=1,target_city='" +
              locationInfo.target_city +
              "',target_state='" +
              locationInfo.target_state +
              "',target_dma='" +
              locationInfo.target_dma +
              "',target_counties='" +
              locationInfo.target_counties +
              "',target_postalcode='" +
              locationInfo.target_zipcode +
              "',target_brands='" +
              locationInfo.target_brands +
              "',target_congressional_districts='" +
              locationInfo.target_congressional_districts +
              "',target_senate_districts='" +
              locationInfo.target_senate_districts +
              "',target_house_districts='" +
              locationInfo.target_house_districts +
              "',latlon_radius='" +
              locationInfo.latlon_radius +
              "',addresses_radius='" +
              locationInfo.addresses_radius +
              "',poi_radius='" +
              locationInfo.poi_radius +
              "',name='" +
              addslashes(locationInfo.name) +
              "',geo_points='" +
              addslashes(locationInfo.target_latlon) +
              "',geo_polygons='" +
              addslashes(locationInfo.target_polygon) +
              "',target_poi='" +
              addslashes(locationInfo.target_poi) +
              "',target_addresses ='" +
              addslashes(locationInfo.target_addresses) +
              "',target_latlon_groups='" +
              locationInfo.target_latlon_group +
              "',target_polygon_groups='" +
              locationInfo.target_polygon_group +
              "',target_address_groups='" +
              locationInfo.target_address_group +
              "',updated_date=" +
              DATASOURCE_CONFIG.CURRENT_DATE +
              " where id='" +
              locationInfo.id +
              "' and bidder_id='" +
              bidderId +
              "' ",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
          });
        }
      }

      if (InsertValuesArr.length > 0) {
        InsertQuery += InsertValuesArr.join(",");
        queriesArr.push({
          query: InsertQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    }

    const queryBody = {
      queries: queriesArr,
    };

    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetBidderLocationGroupThunk = createAsyncThunk(
  "demandpartner/GetBidderLocationGroupThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          /****get campaign location groups data** */
          query:
            "select * from " +
            tablePrefix +
            "bidders_location_groups where bidder_id='" +
            payload.id +
            "' and is_active=1",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetDemandPartnerDetailsThunk = createAsyncThunk(
  "demandpartner/GetDemandPartnerDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select * from " +
            tablePrefix +
            "bidders where id='" +
            payload.id +
            "' and active ='1'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select * from " +
            tablePrefix +
            "publisher_bidder_rev_share where dspid='" +
            payload.id +
            "' and (adsize='' OR adsize is NULL)",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "SELECT assc.dealid,deals.id,deals.name,assc.dealid_bidders_assoc_id  FROM " +
            tablePrefix +
            "rtb_dealid_bidder_assoc AS assc, " +
            tablePrefix +
            "rtb_deals as deals WHERE deals.dealid=assc.dealid and assc.visible=1 AND assc.bidder_id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const UpdateDemandPartnerStatusThunk = createAsyncThunk(
  "demandpartner/UpdateDemandPartnerStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "bidders set active='" +
            payload.status +
            "' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getBidderResponseDataThunk = createAsyncThunk(
  "demandpartner/getBidderResponseDataThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        getBidderResponseDataEndPoint,
        payload
      ); //getBidderResponseDataEndPoint
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAllBidderPubRevShareListThunk = createAsyncThunk(
  "demandpartner/GetAllBidderPubRevShareListThunk",
  async (payload) => {
    const queryBody = {
      userData: {
        is_sys_admin: payload?.authUserData?.is_sys_admin,
        user_id: payload?.authUserData?.user_id,
        show_pub_names:
          payload?.authUserData?.user_permissions?.includes("show_pub_names") ==
          true
            ? 1
            : 0,
      },
    };

    try {
      const response = await axiosApiInstance.post(
        getBidderPubRevShareDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdateAllBidderPubRevShareListThunk = createAsyncThunk(
  "demandpartner/UpdateAllBidderPubRevShareListThunk",
  async (payload) => {
    const queryBody = {
      revshare_info: payload?.revshare_info ? payload?.revshare_info : {},
    };

    try {
      const response = await axiosApiInstance.post(
        updateBidderPubRevShareDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const DemandPartner = createSlice({
  name: "demandpartner",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder

      .addCase(GetAllDemandPartnersListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDemandPartnersListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0]) {
          state.demandPartnersList = action.payload.data?.results[0];
        }
        state.loading = false;
      })
      .addCase(GetAllDemandPartnersListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(GetAllDemandPartnerParameterListThunk.pending, (state) => {
        // state.loading = true;
      })
      .addCase(
        GetAllDemandPartnerParameterListThunk.fulfilled,
        (state, action) => {
          if (action.payload.data?.results[0]) {
            let openrtb = [
              {
                value: "0",
                label: "Open RTB",
                handler: "openrtb",
                method: "POST",
                g_m_s: [],
                i_m_s: [],
                c_m_s: [],
              },
            ];
            let customresultData = action.payload.data?.results[0];

            let finalCustomDspList = customresultData.map((info) => {
              info.g_m_s =
                info.g_m_s != "" && info.g_m_s != null
                  ? JSON.parse(info.g_m_s)
                  : [];
              info.i_m_s =
                info.i_m_s != "" && info.i_m_s != null
                  ? JSON.parse(info.i_m_s)
                  : [];
              info.c_m_s =
                info.c_m_s != "" && info.c_m_s != null
                  ? JSON.parse(info.c_m_s)
                  : [];
              return info;
            });

            console.log("finalCustomDspList", finalCustomDspList);
            state.customDspList = [...openrtb, ...finalCustomDspList];
            state.bidderGroups = action.payload.data?.results[1];
            state.endpointRegionList = action.payload.data?.results[2];
            state.bidderEndPointCount = action.payload.data?.results[3];
            state.parameterFlag = true;
          }
        }
      )
      .addCase(
        GetAllDemandPartnerParameterListThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
          state.loading = false;
        }
      )
      .addCase(InsertBidderDetailsThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(InsertBidderDetailsThunk.fulfilled, (state, action) => {
        // if (
        //   action.payload.data?.results.length > 0 &&
        //   action.payload.data.results.includes("Updated")
        // ) {
        // }
        //state.submitLoading = false;
      })
      .addCase(InsertBidderDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.submitLoading = false;
      })
      .addCase(InsertUpdateBidderDetailsThunk.pending, (state) => {
        // state.submitLoading = true;
      })
      .addCase(InsertUpdateBidderDetailsThunk.fulfilled, (state, action) => {
        if (
          action.payload.data?.results.length > 0 &&
          action.payload.data.results.includes("Updated")
        ) {
        }
        state.submitLoading = false;
      })
      .addCase(InsertUpdateBidderDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.submitLoading = false;
      })
      .addCase(GetBidderLocationGroupThunk.pending, (state) => {
        state.locationGroupLoading = true;
      })
      .addCase(GetBidderLocationGroupThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //state.CampaignsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.locationGroupLoading = false;
      })
      .addCase(GetBidderLocationGroupThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.locationGroupLoading = false;
      })

      .addCase(GetDemandPartnerDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDemandPartnerDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //state.CampaignsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.loading = false;
      })
      .addCase(GetDemandPartnerDetailsThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
      })
      .addCase(UpdateDemandPartnerStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateDemandPartnerStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let demandList = state.demandPartnersList;
          let dpId = action.meta.arg.id;
          let status = action.meta.arg.status;
          demandList.map((dpinfo) => {
            if (dpinfo.id == dpId) {
              dpinfo.active = status;
            }
            return dpinfo;
          });
          // advertiserList = advertiserList.filter((item) => item.id !== advId);
          state.demandPartnersList = demandList;
        }
        state.loading = false;
      })
      .addCase(UpdateDemandPartnerStatusThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(CreateUpdateBidderLocationDetailsThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(
        CreateUpdateBidderLocationDetailsThunk.fulfilled,
        (state, action) => {
          if (
            action.payload.data?.results.length > 0 &&
            action.payload.data.results.includes("Updated")
          ) {
            //state.accountsDetails = action.payload.data.results[0];
          }
          state.submitLoading = false;
        }
      )
      .addCase(
        CreateUpdateBidderLocationDetailsThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
          state.submitLoading = false;
        }
      )
      .addCase(GetAllBidderPubRevShareListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllBidderPubRevShareListThunk.fulfilled, (state, action) => {
        // if (action.payload.data?.results[0]) {
        //   state.demandPartnersList = action.payload.data?.results[0];
        // }
        state.loading = false;
      })
      .addCase(GetAllBidderPubRevShareListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdateAllBidderPubRevShareListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        UpdateAllBidderPubRevShareListThunk.fulfilled,
        (state, action) => {
          // if (action.payload.data?.results[0]) {
          //   state.demandPartnersList = action.payload.data?.results[0];
          // }
          state.loading = false;
        }
      )
      .addCase(
        UpdateAllBidderPubRevShareListThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
          state.loading = false;
        }
      )
      .addCase(getBidderResponseDataThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBidderResponseDataThunk.fulfilled, (state, action) => {
        if (action.payload?.data?.error == false) {
        }
        state.loading = false;
      })
      .addCase(getBidderResponseDataThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      });
  },
});

const { actions, reducer } = DemandPartner;
// Extract and export each action creator by name
export const {
  // resetThemeForm,
  // showHideSwitchAccountModal,
  // switchToAccount,
  // updateDashboardFilter,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
